export default __webpack_public_path__ + "static/media/fv_bok.e95e77a3.svg";